import React, { useState } from "react";
import { FAMILIES } from "../../data/apiReference";

// Chain logo with a branded monogram fallback (no broken images when a remote
// icon is missing or the chain has no logo yet).
const ChainLogo = ({ chain, size = 40, className = "" }) => {
  const [failed, setFailed] = useState(false);
  const accent = FAMILIES[chain.family]?.accent || "#99DFAF";
  const showImg = chain.logo && !failed;

  return (
    <span
      className={`relative inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full border border-white/10 bg-white/[0.04] ${className}`}
      style={{ width: size, height: size }}
      aria-hidden={showImg ? undefined : "true"}
    >
      {showImg ? (
        <img
          src={chain.logo}
          alt={`${chain.name} logo`}
          loading="lazy"
          onError={() => setFailed(true)}
          className="h-full w-full object-cover"
        />
      ) : (
        <span
          className="font-bold uppercase"
          style={{ color: accent, fontSize: Math.max(10, size * 0.42), textShadow: `0 0 12px ${accent}66` }}
        >
          {chain.name.replace(/[^a-z0-9]/gi, "").slice(0, 2)}
        </span>
      )}
    </span>
  );
};

export default ChainLogo;
